import React from 'react';
import { DownloadIcon, Move3dIcon } from 'lucide-react';
import { ModelViewer } from './ModelViewer';
import { cadModels } from '../data/models';
export function ModelLibrary() {
  return <div data-id="element-389" data-mp="1rlresdw4tm4r">
      <p className="flex items-center gap-2 text-[14px] text-muted" data-id="element-390" data-mp="1rlj3gqfnqovo">
        <Move3dIcon className="h-4 w-4" aria-hidden="true" data-id="element-391" data-mp="1mn7u0gt9ygdz" />
        Modelle mit der Maus oder dem Finger drehen
      </p>
      <ul className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5" data-id="element-392" data-mp="2kbhswmxrko0v">
        {cadModels.map(m => <li key={m.id} className="flex flex-col overflow-hidden rounded-[12px] bg-white shadow-[0_0_0_1px_rgba(70,28,64,0.07),0_10px_30px_-16px_rgba(70,28,64,0.18)]" data-id="element-393" data-mp="2fcwtuqu90ae0">
            <div className="aspect-[4/3] bg-canvas" data-id="element-394" data-mp="26a5iss5abgmw">
              <ModelViewer src={m.file} shape={m.shape} label={m.title} data-id="element-395" data-mp="yxn6rlq38wyw" />
            </div>
            <div className="flex flex-1 flex-col p-5" data-id="element-396" data-mp="yvai6pptrocv">
              <p className="text-[13px] text-muted" data-id="element-397" data-mp="uv8pv75zc7a9">{m.category}</p>
              <h3 className="mt-1 text-[17px] font-medium leading-snug text-ink" data-id="element-398" data-mp="1oju1np6jq42j">{m.title}</h3>
              <div className="mt-auto flex items-center justify-between gap-3 pt-5" data-id="element-399" data-mp="1tj6mk4dux12h">
                <p className="text-[13px] text-muted" data-id="element-400" data-mp="1fjnq48uere60">{m.formats.join(' · ')}</p>
                {m.file ? <a href={m.file} download className="inline-flex items-center gap-1.5 text-[14px] font-medium text-ink transition-colors duration-150 hover:text-ink/60" data-id="element-401" data-mp="1jkz93vis1158">
                    <DownloadIcon className="h-4 w-4" data-id="element-402" data-mp="1am5iqmw1h704" />
                    Download
                  </a> : <a href="/b2b-downloadbereich" className="text-[14px] font-medium text-ink transition-colors duration-150 hover:text-ink/60" data-id="element-403" data-mp="vttwdp84uoz5">
                    Auf Anfrage
                  </a>}
              </div>
            </div>
          </li>)}
      </ul>
    </div>;
}